<template>
  <v-dialog :value="isOpen" persistent scrollable>
    <v-card>
      <v-toolbar class="escalon-dialog-header" height="35">
        <img
          class="modal-axis-logo mr-2"
          src="../../assets/AXIS Logo for Dark Backgrounds - Cropped - Grayscale.png">
        <span class="modal-title">Google Authenticator Code</span>
        <v-spacer/>
        <v-btn text @click="$emit('close')">
          <v-avatar size="20" class="mr-2">
            <img :src="require('../../assets/' + coloredAssetUrls.close)">
          </v-avatar>Close
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 90%;">
        <v-container fluid>
          <div>
            <label class="modal-label">Google Authenticator Code*</label>
          </div>
          <v-text-field solo
            id="g"
            v-validate="'required'"
            v-model="GACode"
            name="g"/>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="submit" class="modal-cta">Submit
          <v-avatar size="20" class="ml-2">
            <img :src="require('../../assets/' + coloredAssetUrls.submit)">
          </v-avatar>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "tokenModal",
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      GACode: ""
    };
  },
  methods: {
    submit() {
      this.$emit("submit", this.GACode);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-axis-logo {
  width: 60px;
}
</style>

